import { Box, Grid, IconButton, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useState } from 'react';
import PreviewAnexos from '../../../../utils/PreviewAnexos';
// import InputDocUpload from '../../../../../utils/inputFileUpload/inputDocUpload';


export default function AddAnexos({ formData, setFormData, addanexos = true }) {
    const [previewFiles, setPreviewFiles] = useState([]);
    const [currentFileIndex, setCurrentFileIndex] = useState(0);
    const [previewOpen, setPreviewOpen] = useState(false);

    const handleOpenPreview = (documents, fileIndex = 0) => {
        const valid = documents.filter((d) => typeof d === "string" && d.trim() !== "");
        if (!valid.length) return;
        setPreviewFiles(valid);
        setCurrentFileIndex(fileIndex);
        setPreviewOpen(true);
    };

    const handleClosePreview = () => setPreviewOpen(false);

    const handleNavigate = (index) => {
        if (index >= 0 && index < previewFiles.length) {
            setCurrentFileIndex(index);
        }
    };

    async function HandleChangeFile(file, name) {
        if (!file) return;

        // Garante que file é convertido em array
        const arquivos = Array.from(file);

        setFormData(prev => ({
            ...prev,
            anexos: [...(prev.anexos || []), ...arquivos]
        }));
    }

    // REMOVER anexos SELECIONADAS
    function removerAnexoPorIndice(indice) {
        setFormData(prev => ({
            ...prev,
            anexos: prev.anexos.filter((_, i) => i !== indice)
        }));
    }

    return (
        <>
            {formData?.anexos?.length > 0 &&
                <Box sx={{ backgroundColor: 'rgba(0, 0, 0, 0.03)', padding: '1rem', borderRadius: '4px', m: 2 }}>
                    <Grid container >
                        {formData?.anexos.map((anexo, index) =>
                            <Grid key={index} item xs={12} md={6}>
                                {addanexos &&
                                    <IconButton style={{ height: 10 }} onClick={() => removerAnexoPorIndice(index)}> <CloseIcon color='error' /></IconButton>
                                }
                                <img src={addanexos ? URL.createObjectURL(anexo) : anexo} alt={index} width={'80%'} style={{ margin: 5 }} onClick={() => handleOpenPreview(formData?.anexos, 0)} />
                            </Grid>
                        )}
                    </Grid>

                    <PreviewAnexos
                        files={previewFiles}
                        currentIndex={currentFileIndex}
                        isOpen={previewOpen}
                        onClose={handleClosePreview}
                        onNavigate={handleNavigate}
                    />
                </Box>
            }

            {(addanexos && formData?.anexos?.length < 4) &&
                <div align="center" style={{ borderRadius: 5, marginTop: 10, border: '2px dashed #d1d5db', height: '4rem' }}>
                    <label htmlFor="anexos" style={{ margin: 5, cursor: 'pointer' }} >
                        <Typography variant="subtitle2" >
                            Adicionar anexos (opcional)
                        </Typography>
                    </label>
                    <input disabled={!formData} multiple accept=" image/png, image/jpg, image/jpeg" type="file" name="anexos" id="anexos" style={{ display: 'none' }} onChange={(e) => HandleChangeFile(e.target.files, 'name')} />
                </div>
            }



            {/* USANDO O input PARA FACILITAR O USO DO InputDocUpload */}
            {/* <input disabled={!formData} multiple accept=" image/png, image/jpg, image/jpeg" type="file" name="anexos" id="anexos" style={{ display: 'none' }} onChange={(e) => HandleChangeFile(e.target.files, 'name')} />
            {addanexos &&
                <InputDocUpload
                    fullWidth={true}
                    imputLigth={true}
                    onFileSelect={HandleChangeFile}
                    inputName="anexos"
                    inputTitle="Clica para adicionar anexos (opcional)"
                    inputDescription="Adicionar anexos (opcional)"
                />
            } */}
        </>
    )
}
